import React from 'react'
import { match } from 'ts-pattern'

import Breakfast from './breakfast'
import Lunch from './lunch'
import Dinner from './dinner'

const Icon: React.FC<{ type: string }> = ({ type }) => {
  return match(type)
    .with('breakfast', () => <Breakfast />)
    .with('lunch', () => <Lunch />)
    .with('dinner', () => <Dinner />)
    .otherwise(() => <Lunch />)
}

export default Icon
